import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=d666be50"
import script from "./PeriodFilter.vue?vue&type=script&lang=js"
export * from "./PeriodFilter.vue?vue&type=script&lang=js"
import style0 from "./PeriodFilter.vue?vue&type=style&index=0&id=d666be50&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d666be50')) {
      api.createRecord('d666be50', component.options)
    } else {
      api.reload('d666be50', component.options)
    }
    module.hot.accept("./PeriodFilter.vue?vue&type=template&id=d666be50", function () {
      api.rerender('d666be50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Statistics/PeriodFilter.vue"
export default component.exports